module.exports = __webpack_public_path__ + "img/SISA.fa3bc5aa.png";